//
// forms/data-store.js -- local storage of form data for prefill etc
//
// - Basically just a slim wrapper for localStorage
// - Note that controller() may return null if storage is
//   unavailable for whatever reason
//

import {curry} from '../helpers/functional';
import upto from '../helpers/upto';


// mk_controller - defines interface
// ----------------------------------

function mk_controller() {
  // Browser may throw exceptions under certain circumstances
  // e.g. in private browsing mode.
  try {
    localStorage.setItem('formdata_test', 'local storage availability');
    localStorage.removeItem('formdata_test');

    sessionStorage.setItem('formdata_test', 'session storage availability');
    sessionStorage.removeItem('formdata_test');
  }
  catch (e) {
    return null;
  }

  return {
    get: curry(get, localStorage),        // get(form_item_name)
    set: curry(set, localStorage),        // set(form_item_name, value)
    remove: curry(remove, localStorage),  // remove(form_item_name)

    get_for_session: curry(get, sessionStorage),        // get_for_session(form_item_name)
    set_for_session: curry(set, sessionStorage),        // set_for_session(form_item_name, value)
    remove_for_session: curry(remove, sessionStorage),  // remove_for_session(form_item_name)

    clear,
  };
}


// data_store
// ----------------------------------

function data_store() {
  if (!window.form_data_storage_controller) {
    window.form_data_storage_controller = mk_controller();
  }
  return window.form_data_storage_controller;
}


// get/set/remove
// ----------------------------------

function key(item_name) {
  return `formdata_${item_name}`;
}

function get(storage, item_name) {
  try {
    const k = key(item_name);
    return JSON.parse(storage.getItem(k));
  }
  catch (e) {
    return null;
  }
}

function set(storage, item_name, value) {
  try {
    const k = key(item_name);
    storage.setItem(k, JSON.stringify(value));
    return true;
  }
  catch (e) {
    return false;
  }
}

function remove(storage, item_name) {
  try {
    const k = key(item_name);
    storage.removeItem(k);
    return true;
  }
  catch (e) {
    return false;
  }
}


// clear
// ----------------------------------

function clear() {
  get_keys(localStorage).forEach(k => localStorage.removeItem(k));
  get_keys(sessionStorage).forEach(k => sessionStorage.removeItem(k));
}

function get_keys(storage) {
  function is_formdata_index(i) {
    const k = storage.key(i);
    return k.substr(0, 8) === 'formdata';
  }

  const keys = upto(storage.length)
    .filter(is_formdata_index)
    .map(i => storage.key(i));

  return keys;
}


export {
  data_store,
  clear,
};

